<template>
  <div class="app-shell">
    <main :class="['app-main', { 'app-main--with-tabbar': showTabbar }]">
      <router-view />
    </main>

    <van-tabbar v-if="showTabbar" route>
      <van-tabbar-item to="/youtube" icon="home-o">
        视频库
      </van-tabbar-item>
      <van-tabbar-item to="/profile" icon="user-o">
        个人中心
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { onH5AuthRequired } from './utils/auth'

const route = useRoute()
const router = useRouter()
const showTabbar = computed(() => route.meta?.showTabbar !== false)
let stopAuthRequiredListener = null

onMounted(() => {
  stopAuthRequiredListener = onH5AuthRequired((event) => {
    const redirect = String(event?.detail?.redirect || route.fullPath || '/youtube')
    if (route.path === '/login') return
    router.replace({
      path: '/login',
      query: {
        redirect,
      },
    })
  })
})

onUnmounted(() => {
  stopAuthRequiredListener?.()
})
</script>

<style>
html,
body,
#app {
  margin: 0;
  min-height: 100%;
}

body {
  background:
    radial-gradient(circle at top, rgba(224, 36, 94, 0.12), transparent 34%),
    linear-gradient(180deg, #fff9f5 0%, #f7f8fa 42%, #eef2f7 100%);
}

#app {
  font-family: "Avenir Next", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2937;
}

.app-shell {
  min-height: 100vh;
  background: transparent;
}

.app-main {
  min-height: 100vh;
  box-sizing: border-box;
}

.app-main--with-tabbar {
  padding-bottom: 50px;
}

:root {
  --yt-bg: #f4f6fb;
  --yt-surface: rgba(255, 255, 255, 0.88);
  --yt-surface-strong: #ffffff;
  --yt-line: rgba(15, 23, 42, 0.08);
  --yt-text: #0f172a;
  --yt-muted: #64748b;
  --yt-accent: #e11d48;
  --yt-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  --yt-radius-xl: 28px;
  --yt-radius-lg: 22px;
  --yt-radius-md: 16px;
}

a {
  color: inherit;
  text-decoration: none;
}
</style>
